import { FC, useState, useRef, useEffect } from "react";
import Button from "../../../components/UI/Button/Button";
import { transformGMTToUTC } from "../../../Utility/Utility";
import StaticForm from "../staticImgUploaderForm";

import {
  StaticBannerSectionWrapper,
  DesktopBannerSection,
  BannerSectionTitle,
  AddImageBtn,
  BannerSectionSubtitle,
  StaticFormSection,
  Img,
  ActiveInactivewarpper,
  Img2,
  Img3,
  ImgWrapper,
} from "../StyledPromotions";

import { RootState } from "../../../app/Store";
import {
  createPromotion,
  deletePromotionById,
  disableEnablePromotionById,
  setAdditionalDesktopImgDetails,
  setAdditionalMobileImgDetails,
  setDesktopImgDetails,
  setMobileImgDetails,
  uploadAdditionalPromotionImages,
  uploadPromotionImages,
} from "../../../features/promotions";
import { useSelector, useDispatch } from "react-redux";
import { updatePromotion } from "../../../features/promotions";

import TestStaticForm from "../TempStaticForm";
import useDimension from "../../../costomHook/useDimention";
import * as UIConstants from "../../../UIConstants";

interface StaticImgProps {
  details: any;
  bannerRedirectionUrl: string;
  promotionPosition: string;
}

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}

enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
}

const AuctionStaticImageUploader: FC<StaticImgProps> = ({
  details,
  bannerRedirectionUrl,
  promotionPosition,
}) => {
  const dispatch = useDispatch();
  const dimention = useDimension();

  const [bannerUrl, setBannerUrl] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEnaDate] = useState(new Date());
  const [desktopImgUrl1, setDesktopImgUrl1] = useState("");
  const [mobileImgUrl1, setMobileImgUrl1] = useState("");
  const [id, setId] = useState(0);

  // const dummyImgUrl = "https://dummyimage.com/1920x450/000/fff";

  console.log(details, "details");
  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      setBannerUrl(details.promotionBannerUrl);
      setStartDate(details.promotionStartDate);
      setEnaDate(details.promotionEndDate);
      setDesktopImgUrl1(
        details.promotionWebBannerImages ? details.promotionWebBannerImages : ""
      );
      setMobileImgUrl1(
        details.promotionMobileBannerImages
          ? details.promotionMobileBannerImages
          : ""
      );
      setId(details.promotionId ? details.promotionId : 0);
    }
  }, [details]);

  const [isForDesktopImg, setDesktopImgStatus] = useState(false);

  const desktopImgUrl = useSelector(
    (state: RootState) => state.promotions.desktopImagUrl
  );
  const additionalDesktopImgUrl = useSelector(
    (state: RootState) => state.promotions.additionalDesktopImagUrl
  );
  const mobileImgUrl = useSelector(
    (state: RootState) => state.promotions.mobileImgUrl
  );
  const additionalMobileImgUrl = useSelector(
    (state: RootState) => state.promotions.additionalMobileImgUrl
  );
  const desktopImgName = useSelector(
    (state: RootState) => state.promotions.desktopFileName
  );
  const additionalDesktopImgName = useSelector(
    (state: RootState) => state.promotions.additionalDesktopFileName
  );
  const mobileImgName = useSelector(
    (state: RootState) => state.promotions.mobileFileName
  );
  const additionalMobileImgName = useSelector(
    (state: RootState) => state.promotions.additionalMobileFileName
  );

  const inputRef = useRef<HTMLInputElement | null>(null);

  const triggerImageUploader = (isforDektop: boolean) => {
    setDesktopImgStatus(isforDektop);
    inputRef.current?.click();
  };

  const createUploadFileObj = (event) => {
    uploadFile(event.target.files[0]);
  };

  const uploadFile = (files: any) => {
    const formData = new FormData();
    formData.append("file", files);
    formData.append("documentName", updateFileName(files.name));
    if (promotionPosition === "RIGHT") {
      dispatch(
        uploadAdditionalPromotionImages({
          formObj: formData,
          isForDesktop: isForDesktopImg,
          id: id,
        })
      );
    } else {
      dispatch(
        uploadPromotionImages({
          formObj: formData,
          isForDesktop: isForDesktopImg,
          id: id,
        })
      );
    }
  };

  const updateFileName = (fileName: string): string => {
    let updatedName = "";
    if (
      fileName !== null &&
      fileName !== undefined &&
      fileName.trim().length > 0
    ) {
      fileName.trim().split(" ").join("-");
    }
    return updatedName;
  };

  let createStaticImgObj = () => {
    let mobileBannerUrl =
      mobileImgName.length > 0 ? mobileImgName : desktopImgName;
    // console.log(details,"details")
    let requestObj = {};

    requestObj["promotionId"] = details.promotionId;
    requestObj["promotionPage"] = details.promotionPage;
    requestObj["promotionType"] = "STATIC";
    requestObj["promotionPosition"] = promotionPosition;
    requestObj["promotionStartDate"] = transformGMTToUTC(startDate.toString());
    requestObj["promotionEndDate"] = transformGMTToUTC(endDate.toString());
    requestObj["promotionBannerUrl"] = bannerUrl;
    requestObj["promotionWebBannerImages"] = promotionPosition==="RIGHT"? [additionalDesktopImgName]:[desktopImgName];
    requestObj["promotionMobileBannerImages"] =promotionPosition==="RIGHT"? [additionalMobileImgName]:[mobileImgName];
    requestObj["bannerNo"] = details.bannerNo;
    dispatch(updatePromotion(requestObj));
    // dispatch(createPromotion(requestObj))
    console.log(requestObj);
  };

  const updateDateChange = (date: any, name: string) => {
    if (name === "startDate") {
      setStartDate(date);
    } else {
      setEnaDate(date);
    }
  };

  const updateBannerRedirectionUrl = (url: string) => {
    setBannerUrl(url);
  };

  useEffect(() => {
    if (details !== undefined) {
      if (details.promotionMobileBannerImages !== undefined) {
        const Mobparts = details?.promotionMobileBannerImages[0]?.split("/");
        const MobfileName = Mobparts[Mobparts.length - 1];

        // console.log(MobfileName)
        const Webparts = details?.promotionWebBannerImages[0]?.split("/");
        const WebfileName = Webparts[Webparts.length - 1];

        // console.log(WebfileName)
        if (promotionPosition === "RIGHT") {
          dispatch(
            setAdditionalDesktopImgDetails({
              fileName: WebfileName,
              imgUrl: details?.promotionWebBannerImages[0],
            })
          );
          dispatch(
            setAdditionalMobileImgDetails({
              fileName: MobfileName,
              imgUrl: details?.promotionMobileBannerImages[0],
            })
          );
        } else {
          dispatch(
            setDesktopImgDetails({
              fileName: WebfileName,
              imgUrl: details?.promotionWebBannerImages[0],
            })
          );

          dispatch(
            setMobileImgDetails({
              fileName: MobfileName,
              imgUrl: details?.promotionMobileBannerImages[0],
            })
          );
        }
      }
    }
  }, [details]);

  const desableEnableImageHandler = (id: any) => {
    // console.log(id)
    dispatch(
      disableEnablePromotionById({
        promotionId: id,
        promotionPage: details?.promotionPage,
      })
    );
  };

  return (
    <StaticBannerSectionWrapper>
      <ActiveInactivewarpper>
        <Button
          title={details?.isActive ? "Disable" : "Enable"}
          btnSize={dimention.width<= UIConstants.mobileWidth ?    ButtonSize.sm : ButtonSize.md}
          btnVariant={ButtonVariant.primaryFilled}
          clicked={() => desableEnableImageHandler(details?.promotionId)}
        />
      </ActiveInactivewarpper>
      <input
        type={"file"}
        ref={inputRef}
        style={{ display: "none" }}
        onChange={(event) => {
          createUploadFileObj(event);
        }}
        accept="image/jpeg, image/png, image/jpg, image/tiff"
      />
      <DesktopBannerSection>
        <BannerSectionTitle>Desktop Banner (350x750)</BannerSectionTitle>

        <AddImageBtn
          onClick={() => {
            triggerImageUploader(true);
          }}
        >
          Add image
        </AddImageBtn>
      </DesktopBannerSection>
      {/* {desktopImgUrl1 && <Img src={desktopImgUrl1} alt={"desktop"} />} */}
      {desktopImgUrl && (
        <Img2
          src={
            promotionPosition === "RIGHT"
              ? additionalDesktopImgUrl
              : desktopImgUrl
          }
          alt={"desktop"}
          key={desktopImgUrl}
        />
      )}
      <DesktopBannerSection>
        <BannerSectionTitle>
          Mobile Banner (750x350)
          <BannerSectionSubtitle></BannerSectionSubtitle>
        </BannerSectionTitle>

        <AddImageBtn
          onClick={() => {
            triggerImageUploader(false);
          }}
        >
          Add image
        </AddImageBtn>
      </DesktopBannerSection>
      <ImgWrapper>
      {/* {mobileImgUrl1 && <Img src={mobileImgUrl1} alt={"mobile view"} />} */}
      {mobileImgUrl && (
        <Img3
          src={
            promotionPosition === "RIGHT"
              ? additionalMobileImgUrl
              : mobileImgUrl
          }
          alt={"mobile view"}
          key={mobileImgUrl}
        />
      )}
      </ImgWrapper>
      <StaticFormSection>
        {/* <StaticForm bannerRedirectionUrl={bannerRedirectionUrl} details={details} /> */}
      </StaticFormSection>
      <TestStaticForm
        startDate={startDate}
        endDate={endDate}
        url={bannerUrl}
        onDateChange={updateDateChange}
        onUrlChange={updateBannerRedirectionUrl}
      />
      <Button
        title={"Update"}
        btnSize={dimention.width<= UIConstants.mobileWidth ?    ButtonSize.sm : ButtonSize.md}
        btnVariant={ButtonVariant.primaryFilled}
        clicked={createStaticImgObj}
      >
        Update
      </Button>
    </StaticBannerSectionWrapper>
  );
};

export default AuctionStaticImageUploader;
